export const levelListRoutes = {
  path: '',
  name: 'LeveList',
  component: () => import('@/views/level/index.vue'),
  meta: {
    hidden: false,
    title: 'Leve List'
  }
}
export const oddsDropRoutes = {
  path: '',
  name: 'oddsDropList',
  component: () => import('@/views/oddsDropTemplate/index.vue'),
  meta: {
    hidden: false,
    title: 'oddsDrop List'
  }
}


